(function() {
  'use strict';

  function withAttrs() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        scope.$watch(attrs.kzAttrs, function(newAttrs, oldAttrs) {
          if (oldAttrs) {
            angular.forEach(oldAttrs, function(_value, key) {
              if (!newAttrs || !newAttrs.hasOwnProperty(key)) { // eslint-disable-line
                element.removeAttr(key);
              }
            });
          }

          if (newAttrs) {
            angular.forEach(newAttrs, function(value, key) {
              attrs.$set(key, value);
            });
          }
        }, true);
      }
    };
  }

  angular.module('blocks.utils')
    .directive('kzAttrs', withAttrs);
})();

